import { useConditionallyMount } from '@/hooks/useConditionallyMount';
import { ScheduleHeaderModal } from './ScheduleHeaderModal';
import { useScheduleHeaderModal } from './store';

export const ScheduleHeaderModalLoader = () => {
  const { isOpen } = useScheduleHeaderModal();
  const { mounted, setMounted } = useConditionallyMount(isOpen);

  if (!mounted) {
    return null;
  }

  return <ScheduleHeaderModal onCloseComplete={() => setMounted(false)} />;
};
